<h1 mat-dialog-title>{{title}}</h1>
<mat-dialog-content >
    {{content}}
    <ul *ngIf="isListContent">
        <li *ngFor="let item of contentList">
           {{item}}
        </li>        
      </ul>
</mat-dialog-content>
<mat-dialog-actions>
    <div class="text-right">
        <button mat-button class="magin_5 text-white btn btn-success" [mat-dialog-close]="positiveKey">{{positiveKey}}</button>
        <button *ngIf="showNegativeKey" mat-button class="magin_5 text-white btn btn-danger" mat-dialog-close cdkFocusInitial>{{negativeKey}}</button>
    </div>
</mat-dialog-actions>